import landing from "./landing";
import auth from "./auth.ts";
import registration from "./registration.ts";
import balance from "./balance.ts";
import organization from "./organization";
import shop from "./shop";
import tariff from "./tariff";
import employee from "./employee";
import documents from "./documents";
import history from "./history";
import clients from "./clients";
import wallet from "./wallet";
import files from "./files";
import catalog from "./catalog";
import promotions from "./promotions";
import reviews from "./reviews";
import spread from "./spread";
import managers from "./managers";
import permissions from "./permissions";
import faq from "./faq";
import app from "./app";
import profile from "./profile";
import pushs from "./pushs";
import cashback from "./cashback";

export default {
  auth,
  registration,
  balance,
  organization,
  shop,
  landing,
  tariff,
  employee,
  documents,
  history,
  clients,
  wallet,
  catalog,
  promotions,
  reviews,
  spread,
  managers,
  files,
  permissions,
  faq,
  app,
  profile,
  pushs,
  cashback,

  //SYSTEM
  sys: {
    error: "Ката: ",
    descError: "Сүрөттөмө: ",
    wrongLogin: "Туура эмес логин",
    wrongPass: "Туура эмес сырсөз",
    unknown: "Белгисиз",
    unauthenticated: "Авторизацияланган эмес",
    iikAlready: "Ушул ИИК менен юридикалык жак мурунтан эле бар",
    noMoney: "Баланста каражат жеткисиз",
    wrongPeriod: "ProPlus бир жылга гана",
    noPermissions: "Колдонуучунун керектүү уруксаттары жок.",
    firstLoginManager: "Биринчи жолу кириш жасалды, сырсөздү ойлоп табыңыз",
    limitShops: "Соода пунктун түзүү тариф менен чектелген",
    limitLegalEntity: "Юридикалык жакты түзүү тариф менен чектелген",
    wrongTariff: "Сиздин тарифіңізде бул жеткиликтүү эмес",
    wrongTariffPromo: "Промокод каттоо үчүн ылайыктуу эмес",
    tagExist: "Бул тег мурунтан эле бар",
    503: "Сервер жеткиликтүү эмес",
    blockManager: "Менеджер блоголгон",
    wrongCode: "Туура эмес код",
    codeExists: "Өнөктөштүн промокоду туура эмес киргизилген",
    noExam: "Эмтихан тапшырылган жок",
    noActivateAccount: "Каттоо эсеби активдештирилген жок",
    emailExist:
      "Ушул почта менен ээ мурунтан эле RC GROUP сервистеринде катталган",
    userExist:
      "Ушул почта менен ээ мурунтан эле RC GROUP сервистеринде катталган",
    noAccepted: "Жаңы макулдашуу кабыл алынган жок",
    balanceNotEnough: "Баланста каражат жеткисиз",
    innExist: "Ушул ИНН менен юридикалык жак мурунтан эле бар",
    noTodayChangeTariff:
      "Тарифти учурдуу тариф аягына чейин бир күн калганда гана өзгөртсө болот",
    badToken: "Бул шилтеме жараксыз",
    wrongEmail: "Туура эмес почта",
    emailTaken: "Электрондук дарек мурунтан эле ээленген",
    notAvailableCurrentTariff: "Учурдуу тарифке жеткиликтүү эмес",
    dataNoCorrect: "Маалыматтар туура эмес",
    accountNotFound: "Каттоо эсеби табылган жок",
    TPExist: "Соода пункту мурунтан эле бар",
    serverError: "Сервердин катасы",
    ownerExist: "Каттоо эсеби табылган жок",
    unauthorizedAction: "Сизде жетиштүү укук жок",
    legalEntityExist: "Юридикалык жак табылган жок",
    tariffChangeOneDay:
      "Тарифти учурдуу тариф аягына чейин бир күн калганда гана өзгөртсө болот",
    blockedByTariff: "Тариф боюнча блоголгон",
    documentInProcessOfCreation: "Документ түзүү процессинде",
    emailAlreadyVerified: "Сиздин почтаңыз мурунтан эле тастыкталган!",
    emailConfirmed: "Сиздин почтаңыз ийгиликтүү тастыкталды!",
    codeDoesNotExist: "Киргизилген код жараксыз",
    defaultCashbackCanNotBeDeleted:
      "Бренд картасы жок кардарлар үчүн сыйақы жок кылынбайт",
    cashbackUpdateSuccessful: "Сыйақы пайызы ийгиликтүү жаңыртылды",
    cashbackDeleteSuccessful: "Сыйақы жок кылынды",
    cashbackCreateSuccessful: "Сыйақы түзүлдү",
    fullCashback: "Бренд картасы жок кардар",
    clientGroupAlreadyInUse:
      "Кардарлар тобу мурунтан эле кешбек тобунда колдонулуп жатат",
    enteredAmountIsAlreadyInUse:
      "Киргизилген сыйақы суммасы мурунтан эле коюлган",
    dateStartIsInvalid: "Меердин башталыш күнү туура эмес киргизилген",
    dateEndIsInvalid: "Меердин аяктоо күнү туура эмес киргизилген",
    organizationNotConfirmed: "Юр.жак тастыкталган жок",
    periodNotAvailable: "Тандалган меер сатып алуу үчүн жеткиликтүү эмес",
    notAvailableInYourCountry:
      "Тандалган меер сатып алуу үчүн жеткиликтүү эмес",
    exceededActivatedPromotionLimit:
      "Бир соода пунктуна 3 гана активдештирилген акция",
    tradingPointLimitOnProPlus:
      "ProPlus тарифінде 30дан ашык соода пунктун түзүүгә болот",
    tradingPointLimitOnPromo:
      "ProPlus тарифінде 15тен ашык соода пунктун түзүүгә болот",
    tradingPointLimitOnLight:
      "ProPlus тарифінде 5тен ашык соода пунктун түзүүгә болот",
    wrongDateOrder: "Меердин башталыш күнү аяктоо күнүнөн мурун болушу керек",
    descriptionFormatInvalid:
      "Сүрөттөмө хештегдерди жана эмоджилерди камтыбашы керек",
    descriptionMustNotContainEmoji: "Сүрөттөмө эмоджилерди камтыбашы керек",
    descriptionMinLength:
      "Сүрөттөмө боштуктарды эсепке албаганда 600 символдон узунураак болушу керек",
    descriptionMaxLength: "Сүрөттөмө 3000 символдон ашпашы керек",
    maxFileSizeError: "Файлдын көлөмү 10 Мбайт чектөөсүн ашып кетти",
    addFile:
      "Сүйрөп же <span style='color: #447ECB; cursor: pointer'>файлдарды жүктөңүз</span>",
    balance: "Баланс",
    changeMainOrganizationError:
      "Негизги уюмду өзгөртүү мурунку өзгөртүүдөн кийин 30 күндөн кийин гана мүмкүн",
    resetWallet: "Wallet pass дизайнын нөлдөө ишке ашпады",
    updateWallet: "Wallet pass дизайнын жаңыртуу ишке ашпады",
    userUnauthorized: "Логин же сырсөз туура эмес киргизилди",
    noData: "Маалымат жок",
    kb: "КБ",
    pageUnavailableYet: "Бет учурда жеткиликсиз",
    dateMask: "дд.мм.жжжж",
    sort: "Иреттөө",
    noDataTitle: "Азырынча маалымат жок",
    syncError:
      "Синхрондоп жатканда көйгөй чыкты. Кийинчерээк дагы аракет кылыңыз.",

    enterName: "Аталышын киргизиңиз",
    countries: {
      ru: "Россия",
      kz: "Казакстан",
      md: "Молдова",
      ky: "Кыргызстан",
      uz: "Өзбекстан",
    },
    select_country: "Өлкөнү тандаңыз",
    country: "Өлкө",
    q_date: {
      days: "Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби",
      daysShort: "Жк_Дш_Шш_Шр_Бш_Жм_Иш",
      months:
        "Январь_Февраль_Март_Апрель_Май_Июнь_Июль_Август_Сентябрь_Октябрь_Ноябрь_Декабрь",
      monthsShort: "Янв_Фев_Мар_Апр_Май_Июн_Июл_Авг_Сен_Окт_Ноя_Дек",
    },
    errorTitle: "Бир нерсе туура эмес болду",
    dateFrom: "Маалыматтар башталган күндөн бери жеткиликтүү ",
    dateToToday: " бүгүнкү күнгө чейин",
    dateFormat: "Формат дд.мм.жжжж же дд.мм.жжжж - дд.мм.жжжж",
    showBy: "Көрсөтүү: ",
    showByMobile: "Бойдон: ",
    searchResponseEmpty: "Сиздин суранычыңыз боюнча эч нерсе табылган жок",
    search: "Издөө",
    imageSize: "Мб",
    tagSearchResponseEmpty:
      "Тег табылган жок. Кошуу үчүн Enter же Боштук баскычын басыңыз.",
    from: "Башталышы:",
    to: "Аягы:",
    gender: {
      m: "Эркек",
      f: "Аял",
    },
    500: "Бир нерсе туура эмес болду. Интернет байланышын текшериңиз.",
    soon: "Жакында!",
    fromToPercent: "{from} дан {to} га чейин %",
    fromToDays: "{from} дан {to} га чейин күн",
    timeFormat: "сс:мм – сс:мм",
    language: "Тил",
    copied: "Көчүрүлдү",
    moderationMessage: "Модератордон билдирүү",
    languageSelecting: "Тилди тандоо",
    showMap: "Картаны көрсөтүү",
    hideMap: "Картаны жашыруу",
  },

  message: {
    changesSavedAndSendedToModeration:
      "Өзгөртүүлөр сакталды жана модерацияга жөнөтүлдү",
    changesSuccessSaved: "Өзгөртүүлөр ийгиликтүү сакталды",
    changesSaved: "Өзгөртүүлөр сакталды",
  },

  entity: {
    title: "Уюмдун маалыматтарын кошуңуз",
    thirdStepTitle:
      "Сураныч, маалыматтардын тууралыгын текшериңиз. Эми биз сиздин юридикалык жагыңызды тастыктаганга чейин 24 сааттан 48 саатка чейин күтүүңүз керек.",
    accept: "Мен келишим шарттарын кабыл алам",
    offers: "оферталар",
    titleReject: "Өтүнүч четке кагылды!",
    rejectDescription:
      "Тилекке каршы, сиз берген маалыматтар туура эмес болуп чыкты. Модераторлордон келген жооп менен кеңири таанышыңыз жана юридикалык жак жөнүндөгү маалыматтарга өзгөртүүлөр киргизиңиз.",
    message: "Модераторлордон келген билдирүү:",
    change: "Маалыматтарды өзгөртүү",
    titleWaiting: "Каттоо үчүн рахмат!",
    descriptionWaiting:
      "Учурда сиздин уюмуңуз модерациядан өтүүдө. Биз сиздин маалыматтарыңыздын тууралыгына көзүбүз жеткенден кийин гана жеке кабинетке кире аласыз. Адатта, текшерүү 24 сааттан 48 саатка чейин узайт.",
    descriptionWaitingRu:
      "<p>Учурда сиздин уюмуңуз модерациядан өтүүдө. </p> <p>Биз сиздин маалыматтарыңыздын тууралыгына көзүбүз жеткенден кийин \n" +
      "сиз RC Group өнөктөш кабинетинен кире аласыз. </p>  <p> Адатта, текшерүү 24 сааттан 48 саатка чейин узайт.</p>",
    descriptionWaitingRuWithoutPos:
      "<p>Учурда сиздин уюмуңуз модерациядан өтүүдө. </p> <p>Биз сиздин маалыматтарыңыздын тууралыгына көзүбүз жеткенден кийин \n" +
      "сиз RC Group өнөктөш кабинетинен кире аласыз. </p> <p> Адатта, текшерүү 24 сааттан 48 саатка чейин узайт.</p>",
    downloadAccept: "Төлөм эсебин жүктөп алыңыз",
    addDone: "Юридикалык жакты түзгөнүңүз менен куттуктайбыз!",
    waitingApprove:
      "<p>Учурда сиздин юридикалык жагыңыз текшерүүдөн өтүүдө. Ал 24 сааттан 48 саатка чейин узайт.</p><p>Текшерүүдөн өтүү үчүн, төмөнкү баскычтан жүктөп алып, көрсөтүлгөн юридикалык жактан эсепти төлөшүңүз керек. Сиз ошондой эле жеке кабинеттеги «Менин ишканаларым» - «Документтер» бөлүмүндө «Тест төлөмү» деген аталыш менен эсепти таба аласыз.</p>",
  },

  contacts: {
    title: "Байланыштар",
    subtitle:
      '"МААЛЫМАТТЫК-ФИНАНСЫЛЫК ТЕХНОЛОГИЯЛАР КОРПОРАЦИЯСЫ" АКЦИОНЕРДИК КООМУ ( АК "Инфинтех корпорациясы" ) Юридикалык дарек: 191124, <br/>' +
      "Санкт-Петербург, Красного Текстильщика көч., 10-12-үй, О тамгасы, 6-кабат, 1-Н бөлмө, 624-кабинет <br/> ИНН/КПП 7842216564/784201001 ОГРН 1237800080616",
    mailAddress: "Электрондук почта дареги: ",
  },

  failed: "Ката. Аракет аткарылган жок",
  success: "Аракет ийгиликтүү аткарылды",

  //cabinet layout
  leftPanel: {
    counterparties: "Контрагенттерди текшерүү",
    entities: "Юридикалык жактар",
    tradingPoint: "Соода пункттары",
    paymentMethods: "Төлөм ыкмалары",
    employees: "Кассирлер",
    documents: "Документтер",
    businesses: "Бизнес",
    tariffs: "Тарифтер",
    historyPayment: "Операциялардын тарыхы",
    promotions: "Акциялар",
    actsAndAccounts: "Акттар жана эсептер",
    accrualCashback: "Баллдарды нактоо",
    managers: "Менеджерлер",
    spread: "RC карталарын жайылтуу",
    analytics: "Аналитика",
    points: "Кассирлерге упайлар",
    enterprises: "Менин ишканаларым",
    paymentDecision: "Төлөм чечими",
    portfolio: "Портфель",
    employees_and_managers: "Менин кызматкерлерим",
    loyalty: "Лоялдык программасы",
    clients: "Кардарлар",
    claims: "Өтүнүчтөр",
    claims_history: "Өтүнүчтөрдүн тарыхы",
    claims_groups: "Кардарларды топтоштуруу",
    reviews: "Пикирлер",
    extendTariff: "Тарифтин аракетин узартыңыз",
    changeTo: "тариф өзгөрөт",
    wallet: "Wallet картасынын дизайны",
    accountIs: "Сиз төмөнкүдөй кирдиңиз",
    manager: "менеджер",
    owner: "ээси",
    terminals: "Касса аппараттары",
    terminals_MSPOS: "RC Processing 4 бирдей",
    terminals_LIMON: "MPOS технологиясы",
    FAQ: "RC CITY жөнүндө толугу менен",
    corporate: "Байланыш",
    push: "Wallet Push-билдирүүлөрү",
    tips: "Наакытсыз чайпарақтар",
    eMenu: "Онлайн-каталог",
    documentLaboratory: "Документтер лабораториясы",
    giftCard: "Белек карталары",
    processing: "Processing",
    services: "Сервистер",
    wallets: "Лоялдык карталары",
    clientsList: "Кардарлардын тизмеси",
    marketplaces: "Marketplace'тар",
    PromotionServices: "Жайылтуу",
    PreOrders: "Заказдар",
    PWA: "Колдонмону орнотуу",
    tgNotifications: "Telegram'да билдирүүлөр",
  },
  headerButtons: {
    addCoin: "Толтуруу",
    profile: "Профиль",
    exit: "Чыгуу",
    themLight: "Жарык тема",
    themDark: "Караңгы тема",
  },

  //check counterparties page
  counterparties: {
    title: "Контрагенттерди текшерүү",
    buttonCheck: "Текшерүү",
    question:
      "Каттоо күнү, ИНН, КПП, ОГРН, Негизги ишмердүүлүк түрү, Юридикалык жактын статусу,ИФНС, Юридикалык дарек, Башкы директор, Негиз салуучулар, Уставдык капитал",
    instructionButton: "Контрагенттерди текшерүү үчүн нускама",
    listTitle: "Контрагенттерди текшерүү үчүн Ботту кантип колдонсо болот?",
    listItemFirst: "Текшерүүнү пландаган уюмдун ИНН же ОГРНин киргизиңиз.",
    listItemSecond: "Telegram-Бот сизге бардык керектүү маалыматты көрсөтөт.",
    listItemThird:
      "Блоголгон эсептерди текшерүү үчүн «Эсептерди блоголонусун текшерүү» баскычын басуу керек.",
    listItemFourth:
      "«Эсептерди блоголонусун текшерүү» баскычын баскандан кийин Бот бардык блоголгон эсептерди (анын бар болгондо), ФНС, блоголонгон күнү, № токтому, негизин көрсөтөт. Бул маалыматты толук үйрөнүү үчүн PDF-форматында жүктөп алууга болот: «Отчет менен файлды жүктөп алуу» баскычын басыңыз.",
    instructionCardTitleFirst: "Эмне үчүн контрагенттерди текшерүү керек?",
    instructionCardTitleSecond: "Фактылар жөнүндө өз убагында билиңиз.",
    instructionCardTextFirst:
      "<p>Контрагенттерди текшерүү контрагент менен иш жүргүзүүдө пайда болушу мүмкүн болгон каржылык жана салыктык төңкөрүштөрдү оперативдүү аныктоо үчүн зарыл, жана негизделген чечимдерди кабыл алуу үчүн - өнөктөштүктү улантуу же токтотуу. <br> Бот жаңы жана учурдагы контрагенттерди ар кайса булактар боюнча автоматтык түрдө текшерет жана сизге көңүл бурууну талап кылган критикалык факторлор жана маалыматтар жөнүндө билдирет.</p>",
    instructionCardTextSecond:
      "<p>Боттун жардамы менен сиз бардык контрагенттер базасы боюнча же белгилүү бир бөлүнгөн боюнча массалык текшерүү жана өзгөрүүлөрдөн көз салуу жүргүзө аласыз. Бул кардарлар менен өнөктөштөрдөгү маанилүү өзгөрүүлөргө убагында жооп берүүгө мүмкүндүк берет, акча каражаттарын кайтара албоо төңкөрүшүн төмөндөтөт.</p>",
  },

  // Claims and history claims page
  claims: {
    title: "Өтүнүчтөр",
    historytitle: "Өтүнүчтөрдүн тарыхы",
    group_name: "Топтун аталышы",
    group_nomination: "Топтун аталышы",
    group_sum: "Сатып алуу суммасы (арзандатууларды эсепке албаганда)",
    create_group: "Жаңы топ түзүү",
    edit_group: "Топту редакциялоо",
    delete_group: "Сиз тобу чын эле жок кылгыңыз келеби?",
    sum: "Сумма",
    percent: "Нактоо пайызы",
    noClients: "Азырынча сизде бир да кардар болгон эмес",
    oneClient: "Сизде бир гана кардар болгон",
  },

  //analytic page
  analytics: {
    title: "Аналитика",
    organizationSelect: "Юр жакты тандаңыз",
    organizationButton: "Юридикалык жактар",
    organizationCheckbox: "Бардык уюмдар",
    newOrganizationCheckbox: "Бардык Юридикалык жактар",
    calendar: "Календарь",
    organizations: {
      newClients: "Жаңы кардарлар",
      allClients: "Бардык кардарлар",
      sales: "Сатып алуулар",
      amount: "Сатып алуу суммасы",
      amountCashback: "Анын ичинде баллдар менен берилген",
      average: "Орточо чек",
      averageCashback: "Орточо сыйақы",
    },
    countClients: "Кардарлардын саны",
    topSumEmployee: "Сатып алуу суммасы боюнча топ кассирлер",
    topSaleEmployee: " Сатып алуулар боюнча топ кассирлер",
    points: "Упайлар",
    addPoints: "Накт. баллдар",
    writePoints: "Баллдар менен кабыл алынды",
    rfmAnalysis: "RFM Анализ",
    rfmGroupSizes: "RFM топтордун көлөмдөрү",
    clientPortrait: {
      btn: "Кардардын портрети",
      title: "Кардарлар",
      customerCount: "Кардарлардын саны:",
      receiptAvg: "Орточо чек:",
      receiptCount: "Сатып алуулардын саны:",
      receiptSum: "Сатып алуулардын суммасы:",
      maleFemale: "Э/А:",
      noGender: "Жынысы көрсөтүлгөн эмес:",
    },
  },

  // Answer moderation
  status: {
    moderation: "Модерацияда",
    confirmation: "Тастыкталды",
    confirm: "Тастыкталган",
    reject: "Четке кагылды",
    reject2: "Четке кагылган",
    paid: "Төлөндү",
    active: "Активдүү",
    locked: "Блоголгон",
    activateProcess: "Активдештирүү процессинде",
    awaitingPayment: "Төлөмүн күтүүдө",
    sent: "Жөнөтүлдү",
    received: "Кабыл алынды",
    canceled: "Жокко чыгарылды",
    unknown: "Белгисиз",
    awaitingDocs: "Документ жүктөлүшүн күтүүдө",
    base: "Негизги",
    inProgress: "Иштелип жатат",
    completed: "Аякталды",
    new: "Жаңы",
    readyForIssue: "Берүүгө даяр",
    issuedToClient: "Кардарга берилди",
    undefined: "Белгисиз",
    performed: "Өткөрүлдү",
    inWaiting: "Күтүүдө",
  },

  // Table
  table: {
    searchByTable: "Таблица боюнча издөө",
    status: "Статус",
    nameStatus: "Статустун аталышы",
    percentageAccrual: "Нактоо пайызы",
    fullName: "Аты-жөнү",
    position: "Кызматы",
    phone: "Телефон номуру",
    login: "Логин",
    number: "Номер",
    sum: "Сумма",
    customer: "Сатып алуучу",
    cashback: "Баллдар",
    currency: "Валюта",
    dateTime: "Дата жана убакыт",
    date: "Дата",
    paid: "Төлөндү",
    purchase: "Сатып алуу боюнча",
    transaction: "Транзакция",
    type: "Түрү",
    points: "Упайлар",
    name: "Аты",
    visits: "Келип тургузуу жыштыгы",
    averageCheck: "Сатып алуулардын суммасы",
    birthday: "Туулган күнү",
    age: "Жашы",
    nameAndSurname: "Фамилиясы жана аты",
    store: "Соода пункту",
    entityName: "Уюмдун аталышы",
    operationType: "Операция түрү",
    time: "Убакыт",
  },

  // Common text
  common: {
    nodata: "Сизде дагы соода пункту жок",
    buttonNoData: "Соода пунктун түзүү",
    organizationSelect: "Уюмду тандаңыз",
    allOrganizationCheckbox: "",
    tradingPointsSelect: "Соода пунктун тандаңыз",
    allTradingPointsCheckbox: "Бардык соода пункттары",
    from: "баштап",
    util: "чейин",
    to: "чейин",
    fillField: "Бул талааны толтуруңуз",
    invalidEmail: "Туура эмес почта",
    minLengthPass: "Сырсөз 8 символдон кем эмес",
    fillTime: "Убакытты толтуруңуз",
    calendar: "Календарь",
    filter: "Фильтр",
    filters: "Фильтрлер",
    back: "Артка",
    loadDescription: "Сураныч, халал продукциясынын сертификатын жүктөңүз:",
    loadFormat: ".PDF .JPG .PNG форматындагы сертификаттар колдоого алынат",
    loadSize: "Файлдын салмагы 10 МБден ашпошу керек",
    dropFiles: "Файлды бул жерге сүйрөп же",
    uploadFiles: "жүктөп алыңыз",
    chooseFile: "Файлды тандаңыз",
    fileName: "Файлдын аты",
    Monday: "Дүйшөмбү",
    Tuesday: "Шейшемби",
    Wednesday: "Шаршемби",
    Thursday: "Бейшемби",
    Friday: "Жума",
    Saturday: "Ишемби",
    Sunday: "Жекшемби",
    MondayShort: "Дш",
    TuesdayShort: "Шш",
    WednesdayShort: "Шр",
    ThursdayShort: "Бш",
    FridayShort: "Жм",
    SaturdayShort: "Иш",
    SundayShort: "Жк",
    1: "Дүйшөмбү",
    2: "Шейшемби",
    3: "Шаршемби",
    4: "Бейшемби",
    5: "Жuma",
    6: "Ишемби",
    7: "Жекшемби",
    dayAndNightTime: "Пункт түн бою иштейт",
    notWorkTime: "Пункт иштебейт",
    month: "ай",
    mo: "ай",
    year: "жыл",
    organizations: "Уюмдар",
    shops: "Соода пункттары",
    employees: "Кассирлер",
    managers: "Менеджерлер",
    manager: "Менеджер",
    owner: "Ээси",
    business: "Бизнес",
    tariffs: "Тарифтер",
    historyOperations: "Операциялардын тарыхы",
    actsAndAccounts: "Акттар жана эсептер",
    cashback: "Баллдарды нактоо",
    documents: "Документтер",
    addBalance: "Аванстык төлөм",
    addPoints: "Упайларды нактоо",
    application: "Касса аппаратын төлөө",
    claims: "Өтүнүчтөр",
    analytics: "Аналитика",
    sortNew: "Жаңылыгы боюнча",
    sortAscStars: "Жылдыздардын азаюусу боюнча",
    sortDscStars: "Жылдыздардын өсүшү боюнча",
    email: "email",
    lastName: "Фамилия",
    firstName: "Аты",
    error404: "Ката 404",
    noPage: "Барак табылган жок",
    errorTypeFile: "Файлдын туура эмес түрү!",
    tryTypeFile: "Файл jpg же png болушу керек",
    clients: "Кардарлар",
    exitAccount: "Каттоо эсебинен чыгуу",
    accountsForAct: "Акт боюнча эсеп",
    downloadOn: "жеткиликтүү",
    downloadOnRuStore: "жүктөп алыңыз",
    phone: "Телефон",
    comment: "Комментарий",
    pcs: "даана",
    gb: "ГБ",
    min: "мүн",
    group: "Топ",
    emptyField: "Бардык талааларды толтуруңуз",
    correctField: "Бардык талаалар туура болушу керек!",
    bigFile: "Файлдын чоң көлөмү",
    "e-menu": "Электрондук меню",
    "document-laboratory": "Документтер лабораториясы",
    changesNotSaved: "Киргизилген өзгөртүүлөр сакталган жок",
    statuses: "Статустар",
    phoneNumber: "Телефон номуру",
    mail: "Электрондук почта",
    tgBot: "Telegram бот",
  },

  // Buttons
  button: {
    invite: "Чакыруу",
    download: "Жүктөө",
    edit: "Редакциялоо",
    save: "Сактоо",
    saveChange: "Өзгөртүүлөрдү сактоо",
    saveAndQuit: "Сактоо жана чыгуу",
    accept: "Кабыл алуу",
    change: "Өзгөртүү",
    login: "Кируу",
    create: "Түзүү",
    confirm: "Тастыктоо",
    details: "Кененирээк",
    copy: "Көчүрүү",
    topUp: "Толтуруу",
    back: "Артка",
    send: "Жөнөтүү",
    sendAgain: "Кайра жөнөтүү",
    sendCode: "Кодду жөнөтүү",
    next: "Кийинки",
    proceed: "Улантуу",
    buy: "Сатып алуу",
    goto: "Өтүү",
    open: "Ачуу",
    delete: "Жок кылуу",
    cancel: "Айынуу",
    cancel2: "Айынуу",
    yesCancel: "Ооба, жокко чыгаруу",
    yesQuit: "Ооба, чыгуу",
    yesDelete: "Ооба, жок кылуу",
    pay: "Төлөө",
    ok: "Жакшы!",
    cancelClaim: "Өтүнүчтү жокко чыгаруу",
    generate: "Генерациялоо",
    apply: "Колдонуу",
    applyAndClose: "Колдонуу жана жабуу",
    reset: "Нөлдөө",
    clearAll: "Баарын тазалоо",
    calendarButton: {
      today: "Бүгүн",
      yesterday: "Кечээ",
      lastWeek: "Акыркы 7 күн",
      last30Days: "Акыркы 30 күн",
      lastMonth: "Өткөн ай",
      thisMonth: "Бул ай",
      lastYear: "Өткөн жыл",
      thisYear: "Учурдагы жыл",
      allPeriod: "Бүт меер",
      selectRange: "Өз меериңиз",
    },
    preview: "Алдын ала көрүү",
    resetAll: "Баарын нөлдөө",
    showResult: "Натыйжаларды көрсөтүү",
    upload: "Жүктөө",
    expand: "Кеңейтүү",
    hide: "Жашыруу",
    try: "Аракет кылуу",
    add: "Кошуу",
    reveal: "Көрсөтүү",
    readAll: "Толугу менен окуу",
    collapse: "Жыйыштыруу",
    logout: "Чыгуу",
    show: "Көрсөтүү",
    moreDetails: "Кененирээк",
    settings: "Орнотуулар",
    rollUp: "Жыйыштыруу",
    rollUpAll: "Баарын жыйноо",
    toTariffs: "Тарифтерге",
    forModeration: "Модерацияга",
    quitWithoutSaving: "Сактоосуз чыгуу",
    downloadInvoice: "Эсепти жүктөп алуу",
    notNow: "Азыр эмес",
    createCashier: "Кассир түзүү",
    clearly: "Түшүнүктүү",
    toEdit: "Редакциялоого",
    skip: "Өткөрүп жиберүү",
    backAndSave: "Артка кайтуу жана сактоо",
    done: "Даяр",
    close: "Жабуу",
  },

  month: {
    1: "Январь",
    2: "Февраль",
    3: "Март",
    4: "Апрель",
    5: "Май",
    6: "Июнь",
    7: "Июль",
    8: "Август",
    9: "Сентябрь",
    10: "Октябрь",
    11: "Ноябрь",
    12: "Декабрь",
  },

  charts: {
    pointsAccrued: "Накталган баллдар",
    pointsWritten: "Баллдар менен кабыл алынды",
  },

  eMenu: {
    noData: {
      title: "Электрондук меню боюнча маалымат жок",
      noTradingPoints: "Сизде азырынча Соода пункттары жок ",
      noProducts: "Сизде азырынча бир да товар түзүлгөн эмес",
    },
  },

  validationErrors: {
    emptyField: "Талаа бош болбошу керек",
    invalidEmailFormat: "{email} түрүндөгү email киргизиңиз",
    invalidSiteFormat: "URL http:// же https:// камтышы керек",
    invalidFormat: "Туура эмес формат",
    incorrectValueStart: "Баасын көрсөтүү керек",
    incorrectValueEnd: "чейин",
    invalidValueMaxLength: "Символдордун максималдуу саны ",
    invalidValueMinLength: "Символдордун минималдуу саны ",
    invalidHouseNumber: "Үй номурун тактаңыз",
    invalidAddress: "Даректи тактаңыз",
    writeFullAddress: "Даректи тактаңыз: көчө, үй / имарат / курулуш",
    invalidWorkDays: "Кеминде бир иш күнүн тандашыңыз керек",
    invalidWorkTime: "Убакыттын туура эмес форматы",
    errorWorkTime: "Ачуу убагы жабуу убагынан кеч же ага дал келе албайт",
    notEnoughElement: "Элементтердин жетишсиз саны",
    manyElement: "Сиз элементтердин максималдуу санынан аштыңыз",
    maxLessMin: "Минималдуудан кичине",
    invalidAge: "Туура эмес жаш",
    minDate: "Дата {date} кеч эмес болушу керек",
    maxDate: "Дата {date} мурда эмес болушу керек",
    requiredPhone: "Телефон номурун киргизиңиз",
    reqiredPromocode: "Промокод туура эмес киргизилди",
    requiredCountry: "Өлкөнү тандашыңыз керек",
    havePhone: "Бул телефон мурунтан эле катталган",
    haveMail: "Бул почта мурунтан эле катталган",
    invalidEmail: "Туура эмес почта",
    email: "Почтаны киргизиңиз",
    first_name: "Атыңызды киргизиңиз",
    last_name: "Фамилияңызды киргизиңиз",
    password: "Сырсөздү киргизиңиз",
    corresp_account: "Корсчет көрсөтүлүшү керек",
    number_account: "Эсептин номерин көрсөтүлүшү керек",
    commercial_account_number:
      "Эсеп юридикалык жакка же Жеке ишкерге таандыш болушу керек",
    bik_of_bank: "Банктын БИКин көрсөтүлүшү керек",
    mfo_of_bank: "Банктын МФУсун көрсөтүү керек",
    international_bank: "Банктын эл аралык эсебинин номерин көрсөтүлүшү керек",
    vat_code: "НДС коду көрсөтүлүшү керек",
    inn: "ИНН көрсөтүлүшү керек",
    entityAddress: "Юридикалык даректи көрсөтүлүшү керек",
    fullName: "Аты-жөнүңүздү көрсөтүлүшү керек",
    ogrn: "ОГРН көрсөтүлүшү керек",
    monthly_turnover: "Айлык айланышын көрсөтүлүшү керек",
    deposit_sum: "Депозиттин өлчөмүн көрсөтүлүшү керек",
    tax_system: "Салык салуу түрүн көрсөтүлүшү керек",
    legal_type: "Юридикалык жактын формасын көрсөтүлүшү керек",
    okved_code: "Негизги ишмердүүлүк түрүн көрсөтүлүшү керек",
    minFillingPhotos: "Файлдардын минималдуу саны - {amount}",
    notValidPromocode: "Промокод жок",
    cyrillicOnly: "Кириллица жана латиница гана",
    haveInn: "Юридикалык жак бул {option} менен мурунтан эле бар",
    addressWithoutNumber: "Үй/курулуш номерин, бөлмөнү көрсөтүлүшү керек",
    login: "Логинди киргизиңиз",
    empryNamedField: "{option} көрсөтүлүшү керек",
    passwordMismatch: "Сырсөздөр дал келбейт",
    address: "Үй/курулуш номери менен даректи көрсөтүлүшү керек",
    fieldLengthFromTo: "Талаа {from} дан {to} га чейин сандарды камтышы керек",
    necessaryEnterMinChars: "Кеминде {minChars} символ киргизиш керек",
    workHours: "Тандалган күндөрдө иш сааттарын көрсөтүңүз",
    timeFormat: "Убакыттын туура эмес форматы",
    minImagesUpload: "Кеминде {minImages} сүрөт жүктөңүз",
    wrongMailOrPassword: "Туура эмес почта же сыр сөз",
    wrongLoginOrPassword: "Туура эмес логин же сыр сөз",
    needEnterMinRC: "Кеминде {amount} RC көрсөтүү керек",
  },

  tooltips: {
    registration: {
      deposit:
        "Эсептеги минималдуу калдык. Каражатты чыгарганда баланста кала турган сумма.",
    },
  },

  globalMessagesButton: {
    "tt-update": "Жаңы «Соода пункттары» бөлүмчөсүнө өтүү",
    "clients-update": "Аракет кылуу",
    "product-release": "Аракет кылуу",
    "review-update-release": "Аракет кылуу",
  },

  declinationHelperWords: {
    years: [" жыл", " жыл", " жыл"],
    days: [" күн", " күн", " күн"],
    grades: [" баалоо", " баалоо", " баалоо"],
    symbols: [" символ", " символ", " символ"],
    result: [" натыйжа", " натыйжа", " натыйжа"],
    review: [" пикир", " пикир", " пикир"],
    star: [" жылдыз", " жылдыз", " жылдыз"],
    clients: [" кардар", " кардар", " кардар"],
    product: [" товар", " товар", " товар"],
    entities: [" юридикалык жак", " юридикалык жак", " юридикалык жак"],
  },

  noData: {
    title: "Маалымат жок",
    emptyHistory: "Сиздин тарыхыңыз бош",
  },

  mobileFiltersName: {
    "trading-points": "Соода пункттары",
    category: "Категория",
    "product-status": "Товар статусу",
    "review-status": "Пикир түрү",
    sort: "Иреттөө",
    date: "Меер",
  },

  debt: {
    title: "Карыз",
    text:
      "Аны электрондук почтага жөнөтүлгөн эсеп аркылуу төлөңүз же өзүңүз түзүңүз\n" +
      "«Баланс» бөлүмүндө",
    link: "Карызды төлөөгө өтүү",
    message:
      "Сиз {debt}&nbsp;{currency} өлчөмүндөгү карызыңызды төлөшүңүз керек <br>" +
      "Төлөмдү төмөнкү ыкмалардын бири менен жүргүзсө болот: жеке кабинетте эсеп түзүү же электрондук почтага жөнөтүлгөн эсепти жүктөп алуу.",
  },

  promotionServices: {
    servicesList: {
      "xxl-tag": {
        name: "XXL-өлчөм карточка",
        description:
          "Сиздин мекемеңиздин карточкасынын өлчөмүн жогорулатуу жана ага «Топ орун» бейджин жайгаштыруу",
        fullDescription:
          "<ul>" +
          "<li><span>●</span><p>Сиздин мекемеңиздин карточкасынын өлчөмү чоңойтулат, ошондой эле rcpay.ru сайтындагы жана RC PAY колдонмосундагы «Мекемелер» бетинин алкагында, ага тиешелүү шаар жана категория боюнча «Топ орун» бейджи менен бөлүнөт.</p></li>" +
          "<li><span>●</span><p>Жайгаштыруу мөөнөтү – 1 жума, 1 ай же 3 ай, катнашуучунун кабинетинде буйрук түзүлгөн жана төлөнгөн күндөн баштап.</p></li>" +
          "<li><span>●</span><p>Жайгаштыруу мөөнөтүн буйрук берүү этабында тандаса болот.</p></li>" +
          "<li><span>●</span><p>Бул кызматты буйрук кылганда, сиз ошондой эле картада сиздин мекемеңиздин өзгөчө белгисин аласыз.</p></li>" +
          "</ul>",
      },
      tag: {
        name: "«Топ орун» бейджи",
        description:
          "Сиздин мекемеңиздин карточкасына «Топ орун» бейджин жайгаштыруу жана аны жалпы тизмеде жогору жылдыруу",
        fullDescription:
          "<ul>" +
          "<li><span>●</span><p>Сиздин мекемеңиздин карточкасы «Топ орун» бейджи менен бөлүнөт жана rcpay.ru сайтындагы жана RC PAY колдонмосундагы «Мекемелер» бетинин алкагында, ага тиешелүү шаар жана категория боюнча жогору жылдырылат.</p></li>" +
          "<li><span>●</span><p>Жайгаштыруу мөөнөтү – 1 жума, 2 жума, 1 ай же 3 ай, катнашуучунун кабинетинде буйрук түзүлгөн жана төлөнгөн күндөн баштап.</p></li>" +
          "<li><span>●</span><p>Жайгаштыруу мөөнөтүн буйрук берүү этабында тандаса болот.</p></li>" +
          "<li><span>●</span><p>Бул кызматты буйрук кылганда, сиз ошондой эле картада сиздин мекемеңиздин өзгөчө белгисин аласыз.</p></li>" +
          "</ul>",
      },
      top: {
        name: "Топ 1 же 2 орун",
        description:
          "Сиздин мекемеңиздин карточкасын тизмеде 1 же 2 орунга жайгаштыруу (анын сырткы көрүнүшүн жана өлчөмүн өзгөртпөстөн)",
        fullDescription:
          "<ul>" +
          "<li><span>●</span><p>Сиздин мекемеңиздин карточкасы rcpay.ru сайтындагы жана RC PAY колдонмосундагы «Мекемелер» бетинин тизмесинде 1 же 2 орунга жайгаштырылат, ага тиешелүү шаар жана категория боюнча.</p></li>" +
          "<li><span>●</span><p>1 же 2 орунга жайгаштыруу буйрук берүүнүн жана бул кызматты төлөөнүн ырааттуулугу менен аныкталат.</p></li>" +
          "<li><span>●</span><p>Жайгаштыруу мөөнөтү – 2 жума, катнашуучунун кабинетинде буйрук түзүлгөн жана төлөнгөн күндөн баштап.</p></li>" +
          "<li><span>●</span><p>Бул кызматты буйрук кылганда, сиз ошондой эле картада сиздин мекемеңиздин өзгөчө белгисин аласыз.</p></li>" +
          "</ul>",
      },
      hint: "Учурда сиздин соода пунктуңуздун шаарындагы бул кызмат боюнча бардык жеткиликтүү слоттор ээленген. Буйрук көрсөтүлгөн күндөн баштап мүмкүн болот.",
    },
    periodsList: {
      "7 days": "1 жума",
      "14 days": "2 жума",
      "30 days": "1 ай (30 күн)",
      "90 days": "3 ай (90 күн)",
    },
  },
};
